import { ApprovalService } from './../../../../services/approval.service';
import { ContactService } from './../../../../services/contact.service';
import { Subject, takeUntil } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'concourse-share-request-dialog',
  templateUrl: './share-request-dialog.component.html',
  styleUrls: ['./share-request-dialog.component.scss']
})
export class ShareRequestDialogComponent implements OnInit {

  @Input('projectId') projectId: string = null;
  @Input('selectedRequests') selectedRequests: any = null;
  $unsubscribe = new Subject<void>();
  contacts = [];
  constructor(
    public activeModal: NgbActiveModal,
    public _contactService: ContactService,
    public _approvalService: ApprovalService,
  ) { }
  selectedContact = [];

  ngOnInit(): void {
    this.getAllContactsByProjectId(this.projectId);
  }

  getAllContactsByProjectId(projectId) {
    this._contactService.getAllContacts(projectId).pipe(takeUntil(this.$unsubscribe)).subscribe((response) => {
      this.contacts = response;
    });
  }

  sendRequest() {
    if(this.selectedContact.length && this.selectedRequests.length) {
      let postData = [];
      for(let i=0; i<this.selectedContact.length;i++) {
        for(let j=0; j<this.selectedRequests.length; j++) {
          let obj = {
            approvalrequest: this.selectedRequests[j].id,
            contact: this.selectedContact[i],
          }
          postData.push(obj);
        }
      }
      this._approvalService.shareRequest(postData).pipe(takeUntil(this.$unsubscribe)).subscribe((res) => {
        this.activeModal.close(res);
      });
    }
  }

  ngOnDestroy() {
    this.$unsubscribe.next();
    this.$unsubscribe.complete();
  }

}
